import React from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon,
  makeStyles
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { StoredMessage } from './hook/types';
import { FormattedMessage } from 'react-intl';

// You can swap these out for your own i18n components if needed
// import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  listItem: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  textTruncate: {
    whiteSpace: 'pre-line',
  }
}));

interface RecentMessagesDialogProps {
  messages: StoredMessage[] | null;
  onClose: () => void;
  onSelect: (msg: StoredMessage) => void;
}

export const ChatRecentMessagesDialog: React.FC<RecentMessagesDialogProps> = ({ 
  messages, 
  onClose, 
  onSelect 
}) => {
  const classes = useStyles();

  // If null or empty, don't render the dialog at all
  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <Dialog 
      fullWidth 
      maxWidth="sm" 
      open={true} 
      onClose={onClose}
    >
      <DialogTitle>
        <FormattedMessage id="chat.recent_messages" />
      </DialogTitle>
      
      <DialogContent dividers>
        <List disablePadding>
          {messages.map((msg) => (
            <ListItem 
              button 
              key={msg.timestamp} 
              className={classes.listItem}
              onClick={() => {
                onSelect(msg);
                onClose();
              }}
            >
              <ListItemText 
                primary={msg.text} 
                primaryTypographyProps={{ 
                  className: classes.textTruncate,
                  variant: 'body2' 
                }} 
              />
              {msg.extra?.attachment_file_id && (
                <ListItemIcon style={{ minWidth: 'auto', marginLeft: 8 }}>
                  <AttachFileIcon fontSize="small" color="action" />
                </ListItemIcon>
              )}
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="default">
          <FormattedMessage id="common.close" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
